import { combineReducers } from 'redux'

import appStore from './appStore'
import navigation from './navigation'

export default combineReducers({
  appStore,
  navigation
})
